<template>
  <el-dialog
    title="Chọn thông tin ra trường"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    custom-class="sk-dialog"
  >
    <div class="sk-dialog-content">
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon" style="background: linear-gradient(135deg, #f87171, #dc2626)">
            <i class="el-icon-s-promotion"></i>
          </div>
          <div>
            <p class="sk-panel-title">Học sinh ra trường</p>
            <p class="sk-panel-subtitle">Chọn trạng thái và thời gian chính thức ra trường.</p>
          </div>
        </div>
        <el-form model="dataSearch" label-position="left" label-width="150px">
          <el-form-item label="Chọn trạng thái" prop="idGroupOut">
            <el-select
                style="width: 100%"
                v-model="dataSearch.idGroupOut"
                placeholder="Trạng thái"
            >
              <el-option
                  v-for="item in kidStatusList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Chọn thời gian" prop="dateOut">
            <el-date-picker
                v-model="dataSearch.dateOut"
                type="date"
                :clearable="false"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Ngày ra trường"
                :picker-options="pickerOptions"
                style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer sk-dialog-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close" />
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
        class="btn-save"
        type="success"
        size="medium"
        :loading="loadingButton"
        mini
        @click="submitForm()"
      >
        <i class="el-icon-circle-check" />
        <span>{{ $t("button.save") }}</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import GroupOutService from "@/services/GroupOutService";
import moment from "moment";
export default {
  props: {
    dialogVisible: null,
    listKids: null,
  },
  data() {
    return {
      loadingButton: false,
      kidStatusList: [],
      dataSearch: {
        idGroupOut: "",
        name: "",
        dateOut: moment().format("YYYY-MM-DD"),
      },
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const minDate = new Date(today);
          minDate.setDate(today.getDate());

          // Disable tất cả ngày < hôm nay
          return time.getTime() < minDate.getTime();
        }
      }
    };
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.dataSearch.dateOut = moment().format("YYYY-MM-DD");
      }, 500);
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.dataSearch.dateOut = moment().format("YYYY-MM-DD");
      }, 500);
    },
    submitForm() {
      this.loadingButton = true;
      let data = {
        idList: this.$props.listKids.map((x) => x.id),
        idGroupOut: this.dataSearch.idGroupOut,
        dateOut: this.dataSearch.dateOut,
      };
      GroupOutService.updateKidsGroupOut(data)
        .then((resp) => {
          let count = resp.data.data;
          let messageText =
            count > 0
              ? "Có " + count + " học sinh chưa hoàn thành học phí"
              : resp.data.message;
          this.$message({
            message: messageText,
            type: count > 0 ? "warning" : "success",
          });
          setTimeout(() => {
            this.closeDialog();
          }, 500);
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingButton = false;
          }, 500);
        });
    },
    async getAllGroupOutKidsName() {
      await GroupOutService.getAllGroupOutKidsNameKids()
        .then((resp) => {
          this.kidStatusList = resp.data.data;
          if (this.kidStatusList.length > 0) {
            this.dataSearch.name = this.kidStatusList[0].name;
            this.dataSearch.idGroupOut = this.kidStatusList[0].id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    this.getAllGroupOutKidsName();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>


<style lang="scss" scoped></style>
